import { Alert } from '@mui/material'
import moment from 'moment/moment'
import React from 'react'

import { useRestrictedTimeWindow } from 'hooks/use-restricted-time-window'
import { useTranslation } from 'hooks/use-translation'
import theme from 'theme'

export const RestrictedTimeWindowHeaderAlert: React.FC = () => {
  const { trans } = useTranslation()
  const { isRestrictedTimeWindowActive, windowEnd } = useRestrictedTimeWindow()

  if (!isRestrictedTimeWindowActive) {
    return null
  }

  return (
    <Alert
      css={{
        width: '100%',
        padding: 1,
        paddingLeft: theme.space[1],
        justifyContent: 'center',
        position: 'sticky',
        top: 'var(--header-height)',
        zIndex: theme.zIndices[3]
      }}
      severity="info"
    >
      {trans('restricted_time_window.alert_text', {
        endTime: moment.utc(windowEnd, 'HH:mm').format('h:mm A, dddd')
      })}
    </Alert>
  )
}
